import React from 'react';
import { ComponentType } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { getActive } from './selectors';
import { Currency } from './types';

interface MappedProps {
  currency: Currency;
}

export default function withCurrency<Props>(
  WrappedComponent: ComponentType<Props>,
): ComponentType<Diff<Props, MappedProps>> {
  const Component = (props: Props & MappedProps) => {
    return <WrappedComponent {...(props as any)} />;
  };

  const mapStateToProps = createStructuredSelector({
    currency: getActive,
  });

  return connect(mapStateToProps)(Component as any) as any;
}
